module.exports = __webpack_public_path__ + "static/cliente_11-f35d015e5dedc1b79d01a64045a894eb.png";